import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const GroupIcon = createSvgIcon(
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 4228">
      <path id="Rectangle 3960" d="M1 1H8V8H1V1Z" stroke="#FFFEF4" />
      <path id="Rectangle 3961" d="M8.5 4H10.5V10.5H4V8.5" stroke="#FFFEF4" />
    </g>
  </svg>,
  'group'
);
